import getStore from '../store/store';
import SharedCalendarsOptionViewState from '../store/schema/SharedCalendarsOptionViewState';
import { mutatorAction } from 'satcheljs';

/**
 * Mutator to load shared calendars option store
 */
export default mutatorAction(
    'updateSharedCalendarsInitialState',
    function updateSharedCalendarsInitialState(data: SharedCalendarsOptionViewState) {
        let store = getStore();
        store.calendars = data.calendars;
        store.initialState = data.initialState;
        store.currentState = data.currentState;
        store.calendarsPublish = data.calendarsPublish;
    }
);
